import React, { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Blockquote from '@tiptap/extension-blockquote';
import Link from '@tiptap/extension-link';
import Color from '@tiptap/extension-color';
import { TextStyle } from '@tiptap/extension-text-style';
import Image from '@tiptap/extension-image';
import Toolbar from './Toolbar';
import { cn } from '../../lib/utils';

const RichTextEditor = ({ value, onChange, className, ...props }) => {
    const editor = useEditor({
        extensions: [
            TextStyle,
            Color,
            StarterKit.configure({
                link: false,
                underline: false,
                blockquote: false,
                textAlign: false,
            }),
            Underline,
            Blockquote,
            TextAlign.configure({
                types: ['heading', 'paragraph'],
            }),
            Link.configure({
                openOnClick: true,
                autolink: true,
                defaultProtocol: 'https',
            }),
            Image.configure({
                inline: true,
                allowBase64: true,
            }),
        ],
        content: value,
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        },
        editorProps: {
            attributes: {
                class: 'prose max-w-none focus:outline-none p-4 min-h-[150px]',
            },
        },
    });

    // NOVO: Sincroniza o conteúdo do editor quando a prop 'value' muda
    useEffect(() => {
        if (editor && value !== editor.getHTML()) {
            editor.commands.setContent(value, false); // false para não focar
        }
    }, [editor, value]);


    if (!editor) {
        return null;
    }

    return (
        <div className={cn("border rounded-md overflow-hidden", className)} {...props}>
            <Toolbar editor={editor} />
            <EditorContent editor={editor} />
        </div>
    );
};

export default RichTextEditor;